import SearchableSelect, { SearchableSelectOption } from '../../../../common/filters/SearchableSelect';

interface FilterRowProps {
	filterCreator: string | null;
	filterGameType: string | null;
	filterRacer: string | null;
	filterOptions: {
		creators: SearchableSelectOption[];
		games: SearchableSelectOption[];
		racers: SearchableSelectOption[];
	};
	onFilterChange: (key: 'creator' | 'gameType' | 'racer', value: string | null) => void;
}

export default function FilterRow({
	filterCreator,
	filterGameType,
	filterRacer,
	filterOptions,
	onFilterChange,
}: FilterRowProps) {
	return (
		<div className="paginationContainerRow filtersRow">
			<div className="filterWithClear">
				<SearchableSelect
					label="Creator"
					options={filterOptions.creators}
					value={filterCreator}
					onChange={v => onFilterChange('creator', v)}
					placeholder="All creators"
					id="filter-creator"
				/>
				{filterCreator != null && (
					<button
						type="button"
						className="filterClearBtn"
						onClick={() => onFilterChange('creator', null)}
						aria-label="Clear creator filter"
						title="Clear creator"
					>
						×
					</button>
				)}
			</div>
			<div className="filterWithClear">
				<SearchableSelect
					label="Game type"
					options={filterOptions.games}
					value={filterGameType}
					onChange={v => onFilterChange('gameType', v)}
					placeholder="All games"
					id="filter-gameType"
				/>
				{filterGameType != null && (
					<button
						type="button"
						className="filterClearBtn"
						onClick={() => onFilterChange('gameType', null)}
						aria-label="Clear game type filter"
						title="Clear game type"
					>
						×
					</button>
				)}
			</div>
			<div className="filterWithClear">
				<SearchableSelect
					label="Racer"
					options={filterOptions.racers}
					value={filterRacer}
					onChange={v => onFilterChange('racer', v)}
					placeholder="All racers"
					id="filter-racer"
				/>
				{filterRacer != null && (
					<button
						type="button"
						className="filterClearBtn"
						onClick={() => onFilterChange('racer', null)}
						aria-label="Clear racer filter"
						title="Clear racer"
					>
						×
					</button>
				)}
			</div>
		</div>
	);
}

